import { Component } from 'react';
import {connect} from 'react-redux';
import {actions, Form, } from 'forms/rrf';
import {Col, FormLabel, Row} from 'react-bootstrap';
import ImageUpload from '../../../common/form/elements/image-upload';
import ArrowButton from '../../../common/button-arrow';
import {updatePointsType} from '../../../../actions/points-types';
import RequiredRadioGroup from '../../../common/form/elements/required-radio-group';

const newsFeedOptions = [
  {
    label: 'Yes',
    value: 'true',
  },
  {
    label: 'No',
    value: 'false',
  }
];

class EditPointsTypeForm extends Component {
  onSubmit(payLoad) {
    const {dispatch, pointsType} = this.props;
    dispatch(actions.submitFields('deep.pointsType', updatePointsType(pointsType.id, payLoad)));
  }

  render() {
    const {pointsType, formValid} = this.props;

    let icon;

    const {attributes} = pointsType;

    if (attributes) {
      icon = attributes.link ? attributes.link.icon : undefined;
    }

    return (
      <Form
        model="deep.pointsType"
        onSubmit={this.onSubmit.bind(this)}
      >
        <Row data-test='name'>
          <Col lg={12}>
            <FormLabel>
              Name*
            </FormLabel>
            <div>{attributes.name}</div>
          </Col>
        </Row>
        <Row data-test='icon'>
          <Col lg={12}>
            <FormLabel>
              Icon*
            </FormLabel>
            <ImageUpload
              model=".icon"
              required
              label="Upload an icon"
              sizeLimit={1024 * 1024}
              source={icon}
              type={['image/png', 'image/jpg', 'image/jpeg']}
            />
          </Col>
        </Row>
        <Row data-test='news-feed'>
          <Col lg={12}>
            <FormLabel>
              Display on news feed?*
            </FormLabel>
            <RequiredRadioGroup
              model=".news-feed"
              radios={newsFeedOptions}
              controlId="news-feed"
            />
          </Col>
        </Row>
        <Row data-test='save'>
          <Col lg={12}>
            <ArrowButton
              arrow={false}
              className="float-end"
              disabled={!formValid}
            >
              Save
            </ArrowButton>
          </Col>
        </Row>
      </Form>
    );
  }
}

const mapStateToProps = state => ({
  formValid: state.deep.forms.pointsType.$form.valid,
});

export default connect(mapStateToProps)(EditPointsTypeForm);

